<template>
<div id="app">
  <Baner />
  <Section>
    <Row>
      <selectLocalization />
      <selectTerm />
    </Row>
  </Section>
  <Section>
    <SelectService />
  </Section>
  <Section>
    <ContactForm v-if="!getSubmitState" />
    <div class="text-center error">
      {{ getFirstError }}
    </div>
    <h1 v-if="getSubmitState && getSubmitState.status == 200" v-html="getSubmitState.msg" class="text-center"></h1>
  </Section>
</div>
</template>

<script>
import '@/assets/fonts/stylesheet.css'
import Baner from './components/Baner.vue'
import Section from './components/Section.vue'
import SelectLocalization from './components/SelectLocalization.vue';
import SelectTerm from './components/SelectTerm.vue'
import SelectService from './components/SelectService.vue'
import ContactForm from './components/ContactForm.vue'

import {
  mapGetters
} from 'vuex'

export default {
  name: 'app',
  components: {
    Baner,
    Section,
    SelectLocalization,
    SelectTerm,
    SelectService,
    ContactForm
  },
  computed: {
    ...mapGetters(['getSubmitState', 'getFirstError', 'getValid'])
  }
}
</script>

<style lang="scss">
@import '_variables.scss';
body,
html {
    margin: 0;
    padding: 0;
    font-size: 18px;
    font-weight: 500;
    @media(max-width: 780px) {
        font-size: 14px;
    }
    position: relative;
}
*,
*::before,
*:after {
    box-sizing: border-box;
}
#app {
    font-family: 'AudiType';
}
h2 {
    font-size: 1.7rem;
    @media(min-width:780px) {
        font-size: 2.5rem;
    }
    margin: 1rem;
}
h3 {
    font-size: 1.4rem;
}
label {
    display: block;
    width: 100%;
    padding: 0.5rem;
}
input {
    &[type=text] {
        display: inline-block;
        width: 100%;
        padding: 1rem;
        border-radius: 0.2rem;
        border: 1px solid $gray;
        font-size: 0.9rem;
    }
}
button {
    background: #000;
    color: #fff;
    border: 0;
    border-radius: 2rem;
    padding: 1rem 2rem;
    font-size: 1rem;
    font-family: 'AudiType';
    font-weight: 500;
    cursor: pointer;
    &:hover {
        background: rgb(187, 10, 48);
    }
}
a,
a:visited {
    color: inherit;
    text-decoration: none;
}
.error {
    color: #f00;
    font-weight: bold;
}
.text {
    &-center {
        text-align: center;
    }
}
@for $i from 0 through 10 {
    $procentage: percentage($i/10);
    .flex-item {
        &--#{$i} {
            width: #{$procentage};
        }
        @media (min-width:1430px) {
            &__lg--#{$i} {
                width: #{$procentage};
            }
        }
        @media (max-width:1430px) {
            &__md--#{$i} {
                width: #{$procentage};
            }
        }
        @media (max-width:780px) {
            &__sm--#{$i} {
                width: #{$procentage};
            }
        }
    }
    .p {
        &t {
            &--#{$i} {
                padding-top: #{$i}rem;
            }
        }
        &b {
            &--#{$i} {
                padding-bottom: #{$i}rem;
            }
        }
        &r {
            &--#{$i} {
                padding-right: #{$i}rem;
            }
        }
        &l {
            &--#{$i} {
                padding-left: #{$i}rem;
            }
        }
    }
    .m {
        &t {
            &--#{$i} {
                margin-top: #{$i}rem;
            }
        }
        &b {
            &--#{$i} {
                margin-bottom: #{$i}rem;
            }
        }
        &r {
            &--#{$i} {
                margin-right: #{$i}rem;
            }
        }
        &l {
            &--#{$i} {
                margin-left: #{$i}rem;
            }
        }
    }
}
</style>
